/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation
import xinLianLogo from "./assets/images/XinLian.png";

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  title: "Hi, I'm Letian Xu",
  logo_name: "LetianXu",
  subTitle:
    "Building modern web and mobile applications using TypeScript, React, and Spring Boot. Experienced in backend APIs, cloud deployment, and full-stack system design.",
  resumeLink: "https://your-resume-link.com",
  githubProfile: "https://github.com/LetianXu30"
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/LetianXu30",
  linkedin: "https://www.linkedin.com/in/letian-xu-7b243732a/",
  gmail: "xu.letian@ualberta.ca",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK ENGINEER WITH FRONTEND + BACKEND EXPERIENCE",
  skills: [
    emoji(
      "⚡ Develop web & mobile applications using React, React Native, Expo"
    ),
    emoji(
      "⚡ Backend engineering with Spring Boot, FastAPI, PostgreSQL, Redis"
    ),
    emoji("⚡ Cloud deployment with AWS (EC2, ECS Fargate, SQS, DynamoDB, S3)")
  ],

  softwareSkills: [
    {skillName: "html-5", fontAwesomeClassname: "fab fa-html5"},
    {skillName: "css3", fontAwesomeClassname: "fab fa-css3-alt"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "reactjs", fontAwesomeClassname: "fab fa-react"},
    {skillName: "nodejs", fontAwesomeClassname: "fab fa-node"},
    {skillName: "python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "aws", fontAwesomeClassname: "fab fa-aws"},
    {skillName: "docker", fontAwesomeClassname: "fab fa-docker"},
    {skillName: "sql-database", fontAwesomeClassname: "fas fa-database"}
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "University of Alberta, Canada",
      logo: require("./assets/images/uoa.png"), // 你可以稍后换
      subHeader: "Master of Science in Computing Science (Multimedia)",
      duration: "2024.9 – Present",
      desc: "GPA: 3.9 / 4.0",
      descBullets: [
        "Courses: Virtual Reality Tele-Presence (4.0/4.0), Image & Video Processing (4.0/4.0), AI in Multimedia (3.7/4.0)"
      ]
    },
    {
      schoolName: "Shanghai University, China",
      logo: require("./assets/images/Shu.png"), // 你可以稍后换
      subHeader: "Bachelor of Science in Information and Computing Science",
      duration: "2020.9 – 2024.6",
      desc: "GPA: 3.32 / 4.0",
      descBullets: [
        "Courses: Mathematical Analysis (4.0/4.0), Complex Function Theory (4.0/4.0), Operational Research (4.0/4.0), Advanced Algebra (4.0/4.0), Number Theory (3.7/4.0)"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Full-Stack Software Developer",
      company: "PetoLab, Edmonton, AB, Canada",
      companylogo: require("./assets/images/petolab.png"),
      date: "Oct. 2024 – Present",
      desc: "Cross-platform engineering across React Native, Expo Web, Spring Boot microservices, and AWS infrastructure.",
      descBullets: [
        "Built cross-platform interfaces with React Native and Material-UI; integrated Google Maps, Vision Camera, and media functions.",
        "Developed scalable pipelines using Spring Boot, MySQL, DynamoDB, AWS SQS, Docker, and ECS Fargate.",
        "Integrated Redis Bloom filters for feed ranking, achieving 30k msgs/hour throughput and 60% latency reduction.",
        "Implemented 400+ unit/integration tests and 120+ E2E tests; improved backend coverage to 92%."
      ]
    },
    {
      role: "Full-Stack Software Developer Intern",
      company: "Xinlian Information, Shanghai, China",
      companylogo: xinLianLogo,
      date: "May 2023 – Aug. 2023",
      desc: "Frontend + backend development on enterprise workflow systems.",
      descBullets: [
        "Built attendance system frontend with Vue3; migrated state from Vuex → Pinia improving maintainability by 30%.",
        "Delivered 20+ REST APIs using Spring Boot + PostgreSQL, improving data flow and scalability."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "FULL-STACK, XR, AND ML SYSTEMS",
  projects: [
    {
      projectName: "ArtVerse: Cross-Platform WebXR Collaboration System",
      projectDesc:
        "Immersive metaverse gallery enabling real-time collaboration and art interaction across browsers, mobile, and VR.",
      footerLink: [{name: "View Full Report", url: "/artverse-report"}]
    },
    {
      projectName: "BiasMap: Full-Stack Bias Analytics for 338+ News Sources",
      projectDesc:
        "Large-scale NLP + visualization system analyzing linguistic and factual bias across global media.",
      footerLink: [{name: "View Full Report", url: "/biasmap-report"}]
    },
    {
      projectName: "Diffusion Models with Non-Gaussian Noise",
      projectDesc:
        "Replaced Gaussian noise with bounded triangle-like distributions, achieving competitive or better FID.",
      footerLink: [{name: "View Full Report", url: "/diffusion-report"}]
    },
    {
      projectName: "Fall Detection via SAM2, MediaPipe, and LSTM Fusion",
      projectDesc:
        "Multi-branch spatiotemporal model achieving 94.7% F1 for fall detection in videos.",
      footerLink: [{name: "View Full Report", url: "/fall-detection-report"}]
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: "",
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: "",
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: "",
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1-825-965-7230",
  email_address: "xu.letian@ualberta.ca"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
